import PropTypes from 'prop-types';
import {
  Box, Grid, withStyles, makeStyles, Container, StepLabel, StepConnector, Stepper, Step,
} from '@material-ui/core';
import Check from '@material-ui/icons/Check';
import clsx from 'clsx';
import React from 'react';
import Map from '../containers/Map';
import PersonInfo from '../containers/PersonInfo';
import Summary from '../containers/Summary';

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#784af4',
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool.isRequired,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool.isRequired,
};

function HomeComponent() {
  const [activeStep, setActiveStep] = React.useState(0);

  const steps = ['Pickup and Drop details', 'Basic Contact details', 'Order Summary'];

  const getStepContainer = () => {
    switch (activeStep) {
      case 0:
        return (
          <Grid>
            <Map setActiveStep={setActiveStep} />
          </Grid>
        );
      case 1:
        return (
          <Grid>
            <PersonInfo setActiveStep={setActiveStep} />
          </Grid>
        );
      case 2:
        return (
          <Grid>
            <Summary setActiveStep={setActiveStep} />
          </Grid>
        );
      default:
        return null;
    }
  };

  return (
    <Box>
      <Container>
        <Grid>
          <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>
        {getStepContainer()}
      </Container>
    </Box>
  );
}

export default HomeComponent;
